var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('v-card',{staticStyle:{"height":"85dvh"}},[_c('div',[_c('CreativeEditor',{ref:"imglyEditor",on:{"onSave":_vm.onEditorSave,"close":function($event){_vm.showModal = false}}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }